// method: 'GET', 'POST'
export const callRestful = async (url: any, method: any, headers: any, body: any, callback: any, error: any, isJson: boolean = true) => {
    fetch(url, {
        method: method,
        body: isJson ? JSON.stringify(body) : body,
        headers: headers,
        cache: 'no-cache'
    }).then(response => {
        if (response.ok) {
            return response.text();
        } else {
            throw new Error()
        }
    }).then(r => callback(r))
    .catch((err) => error(err));
}